// extracted by mini-css-extract-plugin
export var brand = "_31-8";
export var compact = "_31-5";
export var extraSmall = "_31-6";
export var icon = "_31-0";
export var large = "_31-3";
export var light = "_31-1";
export var medium = "_31-4";
export var outline = "_31-a";
export var primaryDark = "_31-9";
export var primaryLight = "_31-7";
export var primaryModern = "_31-b";
export var success = "_31-2";